import React from 'react';

import { DesktopHeaderBanner } from './components/HeaderBanner.desktop';
import { OptionalClickable } from './components/OptionalClickable';

import type { PropsFromRedux } from '.';
import { HEADER_BANNER_DATA_TEST_ID } from './constants';
import styles from './components/headerBanner.module.css';

interface IHeaderBanner extends Omit<PropsFromRedux, 'isMapExpanded'> {
  isMapExpanded?: boolean;
  viewRef?: (value: Element | null) => void;
}

export const HeaderBanner = (props: IHeaderBanner): JSX.Element | null => {
  const {
    bannerData,
    isMobile,
    isAvailable,
    isMapExpanded = false,
    viewRef,
  } = props;
  if (!bannerData || !isAvailable || isMapExpanded || isMobile) return null;

  const { desktopText, imageSrc, redirectUrl, backgroundColor, textColor } =
    bannerData;

  return (
    <OptionalClickable href={redirectUrl}>
      <div
        className={styles.mainContainer}
        data-testid={HEADER_BANNER_DATA_TEST_ID}
        ref={viewRef}
        style={{ backgroundColor, color: textColor }}
      >
        <DesktopHeaderBanner desktopText={desktopText} imageSrc={imageSrc} />
      </div>
    </OptionalClickable>
  );
};
